import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Upload, Icon, message, Select, Button } from 'antd'

import { files, users } from '@services/api'

import { fileType } from '@texts/policy'

@inject((store: any) => {
    const { popupStore, authStore } = store

    return {
        popupStore,
        authStore
    }
})
@observer
export default class UploadFilePopup extends Component<any, any> {
    state: any = {
        userInfo: {},
        status: 'waiting',
        selectedType: undefined,
        errors: {}
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
        this.resetUpload()
    }

    resetUpload = () => {
        this.setState({ selectedType: undefined, status: 'waiting' })
    }

    setError = (errorName, errorMsg) => {
        this.props.popupStore.addErrors(errorName, errorMsg)
        return false
    }

    validateFile = () => {
        return true
    }

    saveUser = async () => {
        if (this.validateFile()) {
        }
    }

    handleSelectedType = e => {
        this.setState({ selectedType: e })
    }

    render() {
        const {
            isRegularUse,
            popupStore,
            fileUploaded,
            authStore: { fullName }
        } = this.props
        const { status, selectedType } = this.state
        const { Dragger } = Upload

        const props = {
            multiple: false,
            showUploadList: false,
            customRequest: async request => {
                const { bucket, related, commissionId, uniq } = popupStore.info
                const newFile = await request.file
                const formData = new FormData()
                await formData.append('file', newFile)

                try {
                    const fileObj = await files.upload(formData, { bucket, related, fileType: selectedType, uniq })
                    const file_id = fileObj.data.id

                    isRegularUse &&
                        (await users.updateUploadedFileId({ id: commissionId, file_id, updated_by: fullName }))
                    request.onSuccess(res => res)
                    fileUploaded && fileUploaded()
                } catch (e) {
                    request.onError(e => e)
                }
            },
            onChange: info => {
                const { status } = info.file

                this.setState({ status })
                if (status === 'done') {
                    message.success(`הקובץ הועלה בהצלחה`)
                } else if (status === 'error') {
                    message.error(`אירעה שגיאה בהעלאת הקובץ`)
                }
            }
        }

        const uploadMsgMap = {
            waiting: { text: ' גרור לכאן קובץ להעלאה <br/> או לחץ לבחירת קובץ מתוך תיקיה', icon: 'cloud-upload' },
            uploading: { text: 'אנא המתן! <br/> הקובץ בטעינה...', icon: 'loading' },
            done: { text: ' העלאת הקובץ הצליחה! <br/> סגור חלון או העלה קובץ נוסף', icon: 'check-circle' },
            error: {
                text: `העלאת הקובץ נכשלה <br/> וודא כי הקובץ אינו עולה על 5MB וכי סוג הקובץ הוא ${
                    selectedType === 'doc' ? 'XLSX' : 'PDF'
                }`,
                icon: 'warning'
            }
        }

        const uploadMsg = (
            <Fragment>
                <p className="ant-upload-drag-icon">
                    <Icon type={uploadMsgMap[status].icon} />
                </p>
                <p className="ant-upload-text" dangerouslySetInnerHTML={{ __html: uploadMsgMap[status].text }} />
            </Fragment>
        )

        const footerButtons = (
            <Fragment>
                <Button onClick={() => this.closePopup()}>{status === 'done' ? 'סגור' : 'ביטול'}</Button>
                {status === 'done' || status === 'error' ? (
                    <Button type="primary" onClick={() => this.resetUpload()}>
                        {status === 'done' ? 'העלה קובץ נוסף' : 'נסה שנית'}
                    </Button>
                ) : (
                    ''
                )}
            </Fragment>
        )
        return (
            <Modal
                title="העלאת קובץ"
                visible={popupStore.popupType === 'uploadFile'}
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                {status === 'waiting' && popupStore.info.types && popupStore.info.types.length > 0 ? (
                    <Select
                        style={{ width: '100%' }}
                        placeholder="בחר סוג קובץ"
                        value={selectedType}
                        onChange={e => this.handleSelectedType(e)}
                    >
                        {popupStore.info.types.map(type => (
                            <Select.Option key={type} value={type}>
                                {fileType[type]}
                            </Select.Option>
                        ))}
                        <Select.Option key="הרשאה לחיוב חשבון" value="bank_approval">
                            הרשאה לחיוב חשבון
                        </Select.Option>
                        <Select.Option key="פרטי תשלום" value="payment_details">
                            פרטי תשלום
                        </Select.Option>
                    </Select>
                ) : (
                    ''
                )}

                {selectedType ? (
                    <Dragger disabled={status !== 'waiting'} {...props}>
                        {uploadMsg}
                    </Dragger>
                ) : (
                    ''
                )}
            </Modal>
        )
    }
}
